<template>
  <div style="width: 90vw">
    <el-container style="padding: 25px 25px">


      <div class="bbb1">

        <el-header style="display: flex;height: 40px;">

          <span class="style-title">项目名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <span class="style-title">日期:</span>

          <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              style="margin-left: 5px;margin-top: 9px;height:28px;width: 280px;align-items: center;display: flex"
              size="mini"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions3">
          </el-date-picker>

          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>

          <span class="data-item2 low-roi">总ROI</span>
          <span class="data-item2 big-roi">总倍率</span>
          <span class="data-item2 high-roi">流量主ROI</span>
          <span class="data-item2 medium-roi">广告ROI</span>
          <!--          <el-checkbox-group-->
          <!--              class="style-title"-->
          <!--              v-model="checkedCities"-->
          <!--              :min="1"-->
          <!--              :max="3">-->
          <!--            <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>-->
          <!--          </el-checkbox-group>-->


        </el-header>


        <el-table
            ref="tableData1"
            :data="tableData"
            stripe
            border
            max-height="80vh"
            height="79vh"
            style="margin-top: 11px"
            :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
            size="mini"
            v-loading="loading"
            highlight-current-row

        >

          <el-table-column
              prop="uploadDate"
              label="日期"
              sortable
              min-width="100"
              align="center"

          >
          </el-table-column>

          <el-table-column
              prop="gameName"
              label="游戏名称"
              min-width="180"
              align="center"

          >
          </el-table-column>
          <el-table-column
              prop="adConsume"
              label="账面消耗"
              min-width="120"
              align="center"
              sortable
              :formatter="value_format2"
          >
          </el-table-column>

          <el-table-column
              prop=""
              label="实时ROI"
              min-width="140"
              align="center"
          >
            <template slot-scope="{row}">
              <div class="roi-container">
                <!-- 第一行数据 -->
                <div class="data-row">
        <span class="data-item low-roi">
       {{ ((row.sum + row.sum2) / row.adConsume * 100).toFixed(2)|dataFilters2 }}
        </span>
                  <el-divider direction="vertical"/>
                  <span class="data-item high-roi">
        {{ ((row.sum) / row.adConsume * 100).toFixed(2)|dataFilters2 }}
        </span>
                </div>

                <!-- 第二行数据 -->
                <div class="data-row ">
        <span class="data-item big-roi">
         {{ ((row.sum + row.sum2) / (parseFloat(row.data[0]) + parseFloat(row.data2[0]))).toFixed(2)|dataFilters2 }}
        </span>
                  <el-divider direction="vertical"/>
                  <span class="data-item medium-roi">
       {{ ((row.sum2) / row.adConsume * 100).toFixed(2)|dataFilters2 }}
        </span>
                </div>
              </div>
            </template>


          </el-table-column>

          <el-table-column
              v-for="(item, index) in items"
              :key="index"
              :label="'总ROI ' + (item + 1)"
              min-width="160"
              align="center"
              header-align="center"
              class-name="responsive-column"
          >
            <template slot-scope="{ row }">
              <div class="roi-container">
                <!-- 第一行数据 -->
                <div class="data-row">
        <span
            class="data-item"
            :class="getRoiClass2(parseFloat(row.data[item]) + parseFloat(row.data2[item]))"

        >
          {{
            ((parseFloat(row.data[item]) + parseFloat(row.data2[item])) / row.adConsume * 100).toFixed(2) | dataFilters2
          }}

        </span>
                  <el-divider direction="vertical"/>
                  <span
                      class="data-item"
                      :class="getRoiClass(row.data[item])"
                  >
          {{ (row.data[item] / row.adConsume * 100).toFixed(2) | dataFilters2 }}

        </span>
                </div>

                <!-- 第二行数据 -->
                <div class="data-row">
        <span
            class="data-item   "
            :class="getRoiClass3(parseFloat(row.data[item]) + parseFloat(row.data2[item]))"
        >
             {{
            ((parseFloat(row.data2[item]) + parseFloat(row.data[item])) / (parseFloat(row.data2[0]) + parseFloat(row.data[0]))).toFixed(2) | dataFilters2
          }}





        </span>

                  <el-divider direction="vertical"/>
                  <span
                      class="data-item"
                      :class="getRoiClass4(row.data2[item] )"

                  >
        {{ (row.data2[item] / row.adConsume * 100).toFixed(2) | dataFilters2 }}


        </span>


                </div>
              </div>
            </template>
          </el-table-column>

        </el-table>
        <div class="block">

          <el-pagination
              @current-change="search(true)"
              :current-page.sync="currentPage"
              :page-size="30"
              layout="total, prev, pager, next"
              :total="300"
          >

          </el-pagination>
        </div>

      </div>


    </el-container>

  </div>
</template>
<script>
const cityOptions = ['游戏名', '日期'];
export default {
  name: "ToufangWxBroad",

  data() {

    return {

      dialogFormVisible: false,
      checkedCities: ['游戏名', '日期'],
      activeName: 'third',
      cities: cityOptions,
      isSort: true,
      list: [],
      value1: [],
      currentPage: 1,
      items: [],
      valueScene: '',
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableData: [],
      tableData2: [],
      optionsGame: [],
      valueGame: "",
      value: 0,
      value2: '',
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      isSearch: true,
      form: {
        allDivisionScale: 0,
        divisionScale: 0.1,
        type: '流量主比例',
        date: [],
        checked: true
      },
      formLabelWidth: '140px',


    }


  }, watch: {

    colOptions(valArr) {
      // alert("sss");
      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    }
  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }, dataFilters2(value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || value > 1000) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        return value

      }

    }
  }, methods: {

    get() {

      this.$axios
          .get('/toufang/data/getDefault?type=' + this.form.type, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.form.allDivisionScale = successResponse.data.data

            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })
    },
    change() {


      this.$axios
          .post('/toufang/data/updateDefault', this.form)

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '更新' + this.form.type + '默认值成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    formDate(date) {
      // 将Excel日期转换为JavaScript日期
      const jsDate = new Date((date - 25569) * 86400 * 1000);
      // 将JavaScript日期转换为指定格式：yyyy-MM-dd
      const year = jsDate.getFullYear();
      const month = String(jsDate.getMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    changeExcel(e) {
      const files = e.target.files
      if (files.length <= 0) {
        return false
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        console.log('上传格式不正确，请上传xls或者xlsx格式')
        return false
      }
      // 读取表格
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        const workbook = this.$xlsx.read(ev.target.result, {
          type: "binary"
        })
        const wsname = workbook.SheetNames[0]
        const ws = this.$xlsx.utils.sheet_to_json(workbook.Sheets[wsname])
        console.log('ws:', ws) // 转换成json的数据
        //  dealExcel(ws) ...对数据进行自己需要的操作
        // table2.value = ws

        var tt = this


        ws.forEach(function (element) {

          tt.$axios
              .post("/toufang/data/addIn", {
                date: tt.formDate(element.日期),
                name: element.游戏名称,
                jl: element.激励政策收入,
                pf: element.平台赔付
              })
              .then(successResponse => {

                console.log(successResponse)

                if (successResponse.data.code === 200) {

                  this.$notify({
                    title: '成功',
                    message: "添加成功",
                    type: 'success'
                  });
                }


              }).catch((err) => {
            //请求失败的回调函数
            console.log(err)
            console.log('失败')
          })

        });


      }
      fileReader.readAsBinaryString(files[0])
    },
    edit() {

      this.$axios
          .post('/toufang/data/addBi', this.form)
          .then(successResponse => {

            if (successResponse.data.code === 200) {


              this.dialogFormVisible = false

              this.$message({
                message: '操作成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。(可能还有边距/边框等值，需要根据实际情况加上)
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },
    createExportData() {

      return this.json_data

    },


    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format4(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {

        return value
      }
    }, value_format3(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "次日9点更新"
      } else if (isNaN(value)) {

        return '0'

      } else if (value <= 0) {

        return '0'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufangWx/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    }, handleClick(tab, event) {

      console.log(tab.name)

    },
    search(flag) {


      if (flag) {

        console.log("手动选条件")

        localStorage.setItem("ToufangWxBroad", JSON.stringify({
          name: this.valueGame,
          date: this.value2,
          a: this.activeName,
          checkedCities: this.checkedCities
        }))

      } else {


        if (localStorage.getItem("ToufangWxBroad") != null) {

          console.log("自动刷")

          this.checkedCities = JSON.parse(localStorage.getItem("ToufangWxBroad")).checkedCities

          this.valueGame = JSON.parse(localStorage.getItem("ToufangWxBroad")).name

          this.value2 = JSON.parse(localStorage.getItem("ToufangWxBroad")).date

          this.activeName = JSON.parse(localStorage.getItem("ToufangWxBroad")).a

        }
      }


      this.maxHeight = window.innerHeight - 250;
      if (this.value2 != null && this.value2 !== '') {

        this.tableData = []
        this.loading = true
        var a = {}
        a['adConsume'] = 0
        a['adBi'] = 0
        a['incomBefore'] = 0
        a['gameName'] = '总计'
        a['uploadDate'] = '总计'
        a['profit'] = 0
        this.$axios
            .get('/toufangWx/data/findGame/' + this.value2[0] + "/" + this.value2[1] + "/" + this.currentPage + "?name=" + this.valueGame + "&param=" + this.checkedCities, {})
            .then(successResponse => {

              successResponse.data.data.forEach(function (e) {
                e['profit'] = e.incomBefore + e.adBi - e.adConsume

                a['adConsume'] = a['adConsume'] + e.adConsume
                a['adBi'] = a['adBi'] + e.adBi
                a['profit'] = a.profit + e.profit
                a['incomBefore'] = a['incomBefore'] + e.incomBefore
              })


              // this.tableData.push(a)

              this.tableData = this.tableData.concat(successResponse.data.data)

              this.tableData =  this.tableData.filter(function (e) {

                return e.adConsume>0

              })

              this.loading = false

            })

      }

    },
    // 趋势箭头计算方法
    getTrendArrow(val1, val2) {
      const diff = val2 - val1
      if (diff > 0) return '↑'
      if (diff < 0) return '↓'
      return '→'
    },

    // ROI背景色分类方法
    getRoiClass(roi) {
      if (isNaN(roi)) {
        return ''
      } else if(roi<=0){
        return ''
      }else {

        return 'high-roi'
      }
    },
    getRoiClass2(roi) {
      if (isNaN(roi)) {
        return ''
      } else if(roi<=0){
        return ''
      }else {

        return 'low-roi'
      }
    },
    getRoiClass3(roi) {
      if (isNaN(roi)) {
        return ''
      } else if(roi<=0){
        return ''
      }else {

        return 'big-roi'
      }
    },
    getRoiClass4(roi) {
      if (isNaN(roi)) {
        return ''
      } else if(roi<=0){
        return ''
      }else {

        return 'medium-roi'
      }
    }
  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {

    for (var i = 0; i <= 90; i++) {
      this.items.push(i)

    }
    this.height = window.innerHeight;
    // this.date_format_new()
    this.findGame()
    // this.search()

    this.search(false)
  }


}
</script>


<style scoped>

.data-item:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* 示例：隐藏次要列在移动端 */
@media screen and (max-width: 480px) {
  .secondary-column {
    display: none;
  }
}

.roi-container {
  padding: 8px 0;
}

.data-row {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 4px 0;
}

.data-item {
  flex: 1;
  text-align: center;
  padding: 6px 8px;
  font-size: 13px;
  border-radius: 4px;
  transition: all 0.3s;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.data-item2 {
  margin-top: 8px;
  width: 90px;
  height: 30px;
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.trend-arrow {
  margin-left: 4px;
  font-weight: bold;
}

/* 背景色分类 */
.high-roi {
  background-color: #f0f9eb;

}

.medium-roi {
  background-color: #fdf6ec;

}

.low-roi {
  background-color: #fef0f0;

}

.big-roi {
  background-color: rgba(48, 147, 222, 0.2);

}

/* 趋势箭头颜色 */
.trend-arrow[data-trend="up"] {
  color: #67c23a;
}

.trend-arrow[data-trend="down"] {
  color: #f56c6c;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .responsive-column {
    min-width: 120px !important;
  }

  .data-item {
    padding: 4px 6px;
    font-size: 12px;
  }

  .roi-container {
    padding: 4px 0;
  }
}

@media screen and (max-width: 480px) {
  .responsive-column {
    min-width: 100px !important;
  }

  .data-item {
    font-size: 11px;
    padding: 3px 4px;
  }

  .trend-arrow {
    margin-left: 2px;
  }
}

.el-divider--vertical {
  margin: 0 8px;
  height: 1em;
  background-color: rgba(0, 0, 0, 0.12);
}
</style>